module["exports"] = [
  "Female",
  "Male"
];


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/name/binary_gender.js
// module id = 2607
// module chunks = 1610